import type { CommonAPITeamIdFilter, CommonTeamIdFilter } from '../permissions/filterHelpers';
import type { Fetcher } from '../fetchers';
import type { Status as StatusFilterOptions } from './common';

export { Status as StatusFilterOptions } from './common';

export type DependencyPagination = {
  page?: number;
  count?: number;
}

export enum DepthFilterOptions {
  Direct = 'direct',
  Transitive = 'transitive',
}

export enum LayerDepthFilterOptions {
  Base = 'base',
  Other = 'other',
}

export enum HasIssuesFilterOptions {
  HasIssues = 'hasIssues',
  HasLicensingIssues = 'hasLicensingIssues',
  HasQualityIssues = 'hasQualityIssues',
  HasVulnIssues = 'hasVulnIssues',
  NoIssues = 'noIssues',
}

export enum DependencyFilterKeys {
  Title = 'title',
  Status = 'status',
  Depth = 'depth',
  LayerDepth = 'layerDepth',
  HasIssues = 'hasIssues',
  Licenses = 'licenses',
  Fetchers = 'fetchers',
  ShowIgnored = 'showIgnored',
  RootProjects = 'rootProjects',
}

export type DependencyFilters = {
  [DependencyFilterKeys.Title]?: string;
  [DependencyFilterKeys.Status]?: StatusFilterOptions[];
  [DependencyFilterKeys.Depth]?: DepthFilterOptions[];
  [DependencyFilterKeys.LayerDepth]?: LayerDepthFilterOptions[];
  [DependencyFilterKeys.HasIssues]?: HasIssuesFilterOptions[];
  [DependencyFilterKeys.Licenses]?: string[];
  [DependencyFilterKeys.Fetchers]?: Fetcher[];
  [DependencyFilterKeys.ShowIgnored]?: boolean;
  [DependencyFilterKeys.RootProjects]?: string[];
}

export type DependencyQueryWithFilters = DependencyFilters & DependencyPagination;

export enum ProjectFilterKeys {
  TeamIds = 'teamIds',
}
export type APIProjectFilters = {
  [ProjectFilterKeys.TeamIds]: CommonAPITeamIdFilter;
}

export type ProjectFilters = {
  [ProjectFilterKeys.TeamIds]?: CommonTeamIdFilter;
}
